import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const MacIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M2 3C2 2.44772 2.44772 2 3 2H13C13.5523 2 14 2.44772 14 3V11H2V3Z"
		/>
		<path
			fill="currentColor"
			d="M1 12.2C1 12.0895 1.08954 12 1.2 12H6.29289C6.4255 12 6.55268 12.0527 6.64645 12.1464L6.91213 12.4121C6.96839 12.4684 7.0447 12.5 7.12426 12.5H8.87574C8.9553 12.5 9.03161 12.4684 9.08787 12.4121L9.35355 12.1464C9.44732 12.0527 9.5745 12 9.70711 12H14.8C14.9105 12 15 12.0895 15 12.2V13C15 13.5523 14.5523 14 14 14H2C1.44772 14 1 13.5523 1 13V12.2Z"
		/>
	</svg>
))
